import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgModule,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterStaticLinkDirectiveModule } from '@icilalune/utils';
import { LetModule } from '@ngrx/component';
import { TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'sh-ui-icilalune-logo',
  template: `
    <ng-container *ngrxLet="transloco.langChanges$; let lang">
      <div class="b-split-logo">
        <a class="left" [routerStaticLink]="'/' + lang + '/'">
          <img src="./assets/media/ill-logo-left.svg" />
        </a>
        <a class="middle" [routerStaticLink]="'/' + lang + '/'">
          <img src="./assets/media/ill-logo-center.svg" class="middle" />
        </a>

        <a class="right" [routerStaticLink]="'/' + lang + '/'">
          <img src="./assets/media/ill-logo-right.svg" />
        </a>
      </div>
      <div class="static-logo">
        <a class="middle" [routerStaticLink]="'/' + lang + '/'">
          <img src="./assets/logos/icilalune22-logo-white.svg" class="middle" />
        </a>
      </div>
    </ng-container>
  `,
  styleUrls: ['./icilalune-logo.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IcilaluneLogoComponent {
  @Input()
  set splitMode(splitMode: boolean | undefined) {
    const { nativeElement } = this.el;
    this.renderer.removeClass(nativeElement, 'split');
    if (splitMode) {
      this.renderer.addClass(nativeElement, 'split');
    }
  }

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private el: ElementRef<HTMLElement>,
    protected transloco: TranslocoService
  ) {}
}

@NgModule({
  imports: [CommonModule, RouterStaticLinkDirectiveModule, LetModule],
  declarations: [IcilaluneLogoComponent],
  exports: [IcilaluneLogoComponent],
})
export class IcilaluneLogoComponentModule {}
